export default __webpack_public_path__ + "static/nandini2-05569236c062b5d957da3d60c5a36a34.jpg";